import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/Footer";
import TallyTemplate from "./components/TallyTemplate";

function App() {
  return (
    <>
      <TallyTemplate />
      <Navbar />
      <Home />
      <Main />
      <Footer />
    </>
  );
}

export default App;
